// extracted by mini-css-extract-plugin
export default {"btn":"MyButton_btn__3YUGd","disabled":"MyButton_disabled__4zoHs"};